/******************************************************************************************
 *	Footer Controller
 ******************************************************************************************/
(function() {
  angular.module('rcControllers.footer', []).controller(
    'FooterController',
    /* @ngInject */
    function(_, $rootScope, $scope, locale) {
      var newLanguage = locale.getActiveLanguage();
      newLanguage = _.toLower(newLanguage);

      //Reset link suffix which would default to en
      $scope.legalLinkSuffix = '';

      // A country suffix is required for any language other than en
      if (newLanguage !== 'en') {
        $scope.legalLinkSuffix = '_' + locale.getActiveCountry();
      }

      var today = new Date();
      $scope.currentYear = today.getFullYear();
    }
  );
})();
